import { INTL_IDS } from './messages';

/* eslint-disable max-len, quotes */
export const FETCH_FAQ = 'app/Help/FETCH_FAQ';
export const FETCH_FAQ_FAILURE = 'app/Help/FETCH_FAQ_FAILURE';
export const FETCH_FAQ_SUCCESS = 'app/Help/FETCH_FAQ_SUCCESS';

export const RESET_STATE = 'app/Help/RESET_STATE';

export const SET_SELECTED_LETTER = 'app/Help/SET_SELECTED_LETTER';
export const SET_TARGET_TERM_ID = 'app/Help/SET_TARGET_TERM_ID';

export const SET_VIDEO_MODAL_DATA = 'app/Help/SET_VIDEO_MODAL_DATA';
export const SET_VIDEO_REMAINING_DURATION = 'app/Help/SET_VIDEO_REMAINING_DURATION';

export const UPDATE_SELECTED_CATEGORY = 'app/Help/UPDATE_SELECTED_CATEGORY';
export const UPDATE_SELECTED_QUESTION = 'app/Help/UPDATE_SELECTED_QUESTION';

export const UPDATE_STEP = 'app/Help/UPDATE_STEP';

export const FETCH_ERROR_MESSAGE = 'An error has occurred while trying to retrieve your information. If this issue persists, please call customer service at';

// TODO: add mobile paths
export const HELP_HOME_CARD_PROPS = [
  {
    ariaLabel: 'Learn more about Hardship Assistance',
    body: 'Explore all of the options that may help you keep your home during these difficult financial times.',
    desktopPath: '/help/hardshipassistance',
    heading: 'Hardship Assistance',
    linkLabel: 'Learn More',
    // mobilePath: '',
  },
  {
    ariaLabel: 'Learn more about Disaster Assistance',
    body: 'Learn about the resources available to help you repair your home after a natural disaster.',
    desktopPath: '/help/disasterassistance',
    heading: 'Disaster Assistance',
    linkLabel: 'Learn More',
    // mobilePath: '',
  },
  {
    ariaLabel: 'Visit the learning center',
    body: 'Insurance should be accessible to everyone. View educational videos, a glossary, and more.',
    desktopPath: '/help/learningcenter',
    heading: 'Learning Center',
    linkLabel: 'Visit',
    // mobilePath: '',
  },
  {
    ariaLabel: 'View details for contacting various departments',
    body: 'Details on how to get in touch with different departments.',
    desktopPath: '/contactus',
    heading: 'Contact Information',
    linkLabel: 'View Details',
    // mobilePath: '',
  },
];

/* Hardship Assistance Tooltips */

export const REPAYMENT_PLAN_TEXT = `Repayment plans work best for borrowers
who have missed one or more payments, due to an unexpected expense,
but otherwise have a steady source of income that allows them to make their future payments
in full and on time. A repayment plan allows you to take the amount
you are behind on your mortgage, including any late payment fees and penalties,
and pay it off a little at a time, by increasing your monthly mortgage payment in small amounts.`;

export const MODIFICATION_TEXT = `A loan modification adjusts the terms of your mortgage,
such as your interest rate or term, in order to bring the loan current, and if possible,
reduce your monthly payment.`;

export const FOREBEARANCE_TEXT = `Temporary forbearance plans work best for borrowers
who have recently faced or are facing unexpected hardships such as unemployment,
divorce, death, disaster, or disability. This option may reduce or suspend your mortgage
payment for a specific period of time to allow you to recover from this hardship to resolve
loss of employment or make better use of your resources allowing you to pursue a permanent
hardship solution.`;

/* Disaster Assistance View */

export const DISASTER_ADDITIONAL_INFO_CARDS_ARRAY = [
  // {
  //   disclosureName: 'hurricaneIda',
  //   iconName: 'disasterHurricane',
  //   label: 'Learn More',
  //   text: 'Additional information and resources for those impacted by the hurricane',
  //   title: 'Hurricane Ida',
  // },
  // {
  //   disclosureName: 'californiaWildfires',
  //   iconName: 'disasterWildfire',
  //   label: 'Learn More',
  //   text: 'Additional information and resources for those impacted by the California Wildfires.',
  //   title: 'California Wild Fires',
  // },
  {
    disclosureName: 'disasterAssistance',
    iconName: 'disasterClipboard',
    label: 'Learn More',
    text: 'Resources on how to prepare for natural disasters.',
    title: 'Plan Ahead for Disasters',
  },
];

export const DISASTER_CARDS_ARRAY = [
  {
    ariaLabel: 'Visit the Learning Center to view the claims overview video',
    iconName: 'disasterForms',
    label: 'Claims Overview Video',
    path: { desktop: '/help/learningcenter', mobile: 'LearningCenter' },
    text: INTL_IDS.DISASTER_ASSISTANCE_CARD_TEXT_STEP1,
    title: `Step 1${'\n'}File a Disaster Claim`,
  },
  {
    ariaLabel: 'Learn more about insurance claims',
    disclosureName: 'disasterAssistanceStep2',
    iconName: 'disasterMagnify',
    label: 'Learn More',
    text: INTL_IDS.DISASTER_ASSISTANCE_CARD_TEXT_STEP2,
    title: `Step 2${'\n'}Learn About Insurance Claims`,
  },
  {
    ariaLabel: 'Learn more about payment assisance options',
    disclosureName: 'disasterAssistanceStep3',
    iconName: 'disasterShield',
    label: 'Learn More',
    text: INTL_IDS.DISASTER_ASSISTANCE_CARD_TEXT_STEP3,
    title: `Step 3${'\n'}Payment Assistance Options`,
  },
  {
    ariaLabel: 'Learn more about federal disaster assistance',
    disclosureName: 'disasterAssistanceStep4',
    iconName: 'disasterUmbrella',
    label: 'Learn More',
    text: INTL_IDS.DISASTER_ASSISTANCE_CARD_TEXT_STEP4,
    title: `Step 4${'\n'}Apply for Federal Disaster Assistance`,
  },
];

export const VIDEO_CARD_LOOKUP = [
  {
    heading: 'Mortgage Statement Overview & Paperless Billing',
    text: 'Detailed overview of a monthly mortgage statement and the benefits of paperless billing',
  },
  {
    heading: 'Payment Assistance Options',
    text: 'Options available when a financial hardship impacts mortgage payments',
  },
  {
    heading: 'How To Read Your Escrow Statement',
    text: 'Detailed overview of the various sections of the escrow statement, including sample calculations',
  },
  {
    heading: 'Understanding Insurance Claims',
    text: 'Steps to filing a claim including a review of the loss draft check process',
  },
  {
    heading: 'Understanding Lender Placed Insurance',
    text: 'Importance of maintaining adequate insurance coverage on your home',
  },
  {
    heading: 'Understanding Year End Tax Documents',
    text: 'Review of mortgage loan year end tax documents to aid in tax preparation',
  },
];

export const VIDEO_URL_DICT = {
  'How To Read Your Escrow Statement': {
    languages: [
      {
        captionUrl: 'https://dudhzjl76se9h.cloudfront.net/v2/Dovenmuehle+2021+How+To+Read+Your+Escrow+Statement.vtt',
        label: 'English',
        tag: 'en',
        transcriptUrl: 'https://dudhzjl76se9h.cloudfront.net/v2/How_to_Read_Your_Escrow_Statement_v1.pdf',
      },
      {
        captionUrl: 'https://dudhzjl76se9h.cloudfront.net/v2/How+To+Read+Your+Escrow+Statement-ES.vtt',
        label: 'Spanish',
        tag: 'es',
        transcriptUrl: 'https://dudhzjl76se9h.cloudfront.net/v2/How+to+Read+Your+Escrow+Statement+(Spanish).pdf',
      },
    ],
    videoUrl: 'https://dudhzjl76se9h.cloudfront.net/v2/v2_360p.mp4',
  },
  'Mortgage Statement Overview & Paperless Billing': {
    languages: [
      {
        captionUrl: 'https://dudhzjl76se9h.cloudfront.net/v11/Dovenmuehle+Mortgage+Statement+Overview+%26+Paperless+Billing.vtt',
        label: 'English',
        tag: 'en',
        transcriptUrl: 'https://dudhzjl76se9h.cloudfront.net/v11/Video_Transcript-Mortgage_Statement_Overview_Paperless_Billing.pdf',
      },
      {
        captionUrl: 'https://dudhzjl76se9h.cloudfront.net/v11/Mortgage+Statement+Overview+%26+Paperless+Billing-ES.vtt',
        label: 'Spanish',
        tag: 'es',
        transcriptUrl: 'https://dudhzjl76se9h.cloudfront.net/v11/Mortgage+Statement+Overview+%26+Paperless+Billing+(Spanish).pdf',
      },
    ],
    videoUrl: 'https://dudhzjl76se9h.cloudfront.net/v11/v11_720p.mp4',
  },
  'Payment Assistance Options': {
    languages: [
      {
        captionUrl: 'https://dudhzjl76se9h.cloudfront.net/v1/Dovenmuehle+Payment+Assistance+Options.vtt',
        label: 'English',
        tag: 'en',
        transcriptUrl: 'https://dudhzjl76se9h.cloudfront.net/v1/Payment_Assistance_Options_v1.pdf',
      },
      {
        captionUrl: 'https://dudhzjl76se9h.cloudfront.net/v1/Payment+Assistance+Options-ES.vtt',
        label: 'Spanish',
        tag: 'es',
        transcriptUrl: 'https://dudhzjl76se9h.cloudfront.net/v1/Payment+Assistance+Options+(Spanish).pdf',
      },
    ],
    videoUrl: 'https://dudhzjl76se9h.cloudfront.net/v1/v1_360p.mp4',
  },
  'Understanding Insurance Claims': {
    languages: [
      {
        captionUrl: 'https://dudhzjl76se9h.cloudfront.net/v6/Dovenmuehle+Understanding+Insurance+Claims.vtt',
        label: 'English',
        tag: 'en',
        transcriptUrl: 'https://dudhzjl76se9h.cloudfront.net/v6/Understanding_Insurance_Claims_v1.pdf',
      },
      {
        captionUrl: 'https://dudhzjl76se9h.cloudfront.net/v6/Understanding+Insurance+Claims-ES.vtt',
        label: 'Spanish',
        tag: 'es',
        transcriptUrl: 'https://dudhzjl76se9h.cloudfront.net/v6/Understanding+Insurance+Claims+(Spanish).pdf',
      },
    ],
    videoUrl: 'https://dudhzjl76se9h.cloudfront.net/v6/v6_360p.mp4',
  },
  'Understanding Lender Placed Insurance': {
    languages: [
      {
        captionUrl: 'https://dudhzjl76se9h.cloudfront.net/v7/Dovenmuehle+Understanding+Lender+Placed+Insurance.vtt',
        label: 'English',
        tag: 'en',
        transcriptUrl: 'https://dudhzjl76se9h.cloudfront.net/v7/Understanding_Lender_Placed_Insurance_v1.pdf',
      },
      {
        captionUrl: 'https://dudhzjl76se9h.cloudfront.net/v7/Understanding+Lender+Placed+Insurance-ES.vtt',
        label: 'Spanish',
        tag: 'es',
        transcriptUrl: 'https://dudhzjl76se9h.cloudfront.net/v7/Understanding+Lender+Placed+Insurance+(Spanish).pdf',
      },
    ],
    videoUrl: 'https://dudhzjl76se9h.cloudfront.net/v7/v7_360p.mp4',
  },
  'Understanding Year End Tax Documents': {
    languages: [
      {
        captionUrl: 'https://dudhzjl76se9h.cloudfront.net/v8/Dovenmuehle+Understanding+Year-End+Tax+Documents.vtt',
        label: 'English',
        tag: 'en',
        transcriptUrl: 'https://dudhzjl76se9h.cloudfront.net/v8/Understanding_Year-End_Tax_Documents_v1.pdf',
      },
      {
        captionUrl: 'https://dudhzjl76se9h.cloudfront.net/v8/Understanding+Year-End+Tax+Documents-ES.vtt',
        label: 'Spanish',
        tag: 'es',
        transcriptUrl: 'https://dudhzjl76se9h.cloudfront.net/v8/Understanding+Year-End+Tax+Documents+(Spanish).pdf',
      },
    ],
    videoUrl: 'https://dudhzjl76se9h.cloudfront.net/v8/v8_360p.mp4',
  },
};

/* Contact Us View */
export const FAX_NUMBER_CS_DEPT = '1-847-574-7659';
export const RESPA_BANNER_MESSAGE = '<b>RESPA Notices of Error and Requests for Information</b> must be sent only to the address indicated below, <u>including the specific Attention line noted</u>.';
export const TDD_NUMBER_COLLECTIONS = '1-866-352-7564';
export const TDD_NUMBER_CS_DEPT = '1-866-352-3684';
export const CONTACT_ADDRESS_LINE1 = '1 Corporate Drive, Suite 360';
export const CONTACT_ADDRESS_LINE2 = 'Lake Zurich, IL 60047-8945';
